import styled from 'styled-components'
import {
  Div,
} from 'konsys-ui'
import Img from '../common/img'
import { media, theme } from '../../styles/_variables'

export const Container = styled.div`
  padding: 28px 60px 72px 360px;
  width: 100%;
  height: 100%;
  overflow-y: auto;
  background-color: ${props => props.background};
  ${media.tablet`
    padding: 28px 60px 72px 126px;
  `}
  ${media.mobileL`
    padding: 24px 16px 24px 16px;
  `}
`

export const Header = styled(Div)`
  padding: 0 40px 24px;
`

export const Main = styled.div`
  display: flex;
  background-color: #F6F5F5;
`

export const RowContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
`

export const Image = styled(Img)`
  width: 70px;
  height: 70px;
  margin-right: 24px;
`

export const NumBox = styled.div`
  padding: 0 2px;
  height: 15px;
  background: red;
  position: relative;
  font-size: 10px;
  color: white;
  text-align: center;
  font-weight: 500;
  right: 6px;
  bottom: 8px;
`

export const NotiWrapper = styled.div`
  display: ${props => (props.display ? 'block' : 'none')};
  height: 100%;
  width: 100%;
  position: absolute;
  z-index: 0;
`

export const NotiBox = styled.div`
  display: ${props => (props.display ? 'block' : 'none')};
  position: absolute;
  top: 80px;
  right: 200px;
  background: ${theme.color.offWhite};
  border-radius: 4px;
  box-shadow: 0 0 8px 0 ${theme.color.coolGrey};
  overflow: hidden;
  z-index: 1;
`

export const EachNoti = styled.div`
  padding: 8px 16px;
  /* background: ${props => (props.read ? theme.color.offWhite : theme.color.primaryColor)};
  color: ${props => (props.read ? theme.color.black : theme.color.offWhite)}; */
  background: ${theme.color.offWhite};
  color: ${theme.color.black};
  cursor: pointer;
  :hover {
    /* background: ${props => (props.read ? 'rgb(223, 223, 223, 0.5)' : theme.color.secondaryColor)}; */
    background: rgb(223, 223, 223, 0.5);
  }
`

export const ShowAll = styled.div`
  padding: 12px 0;
  cursor: pointer;
  text-align: center;
  margin: 8px 0 0;
  :hover {
    text-decoration: underline;
    background: rgb(223, 223, 223, 0.5);
  }
`

export default Container
